import script from "./IconTextConfirm.modal.vue?vue&type=script&setup=true&lang=js"
export * from "./IconTextConfirm.modal.vue?vue&type=script&setup=true&lang=js"

import "./IconTextConfirm.modal.vue?vue&type=style&index=0&id=65d9de26&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QIcon,QBtn});
